import { createContractRequest } from './helper';
export const getEmptyOffer = createContractRequest({
    route: '/contract/offers/empty',
    method: 'get',
    source: 'data',
});
